var render = function () {
  var _vm$currentRound$cont;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage q-and-a"
  }, [_vm.showActivity ? _c('div', [_c('div', {
    staticClass: "left-side"
  }, [_c('img', {
    attrs: {
      "src": (_vm$currentRound$cont = _vm.currentRound.contentImage) === null || _vm$currentRound$cont === void 0 ? void 0 : _vm$currentRound$cont.image.src
    }
  })]), _c('div', {
    staticClass: "right-side"
  }, [_c('div', {
    staticClass: "q-a-instructions"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.instructions)
    }
  })]), _c('div', {
    staticClass: "steps-container"
  }, [_c('div', {
    staticClass: "step-wrapper step-question"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Question:")]), _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.steps[0].question,
      "text-step": 0,
      "round-id": _vm.currentRound.roundIndex
    }
  })], 1), _c('div', {
    staticClass: "step-wrapper step-answer"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Answer:")]), _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.steps[0].answer,
      "text-step": 1,
      "round-id": _vm.currentRound.roundIndex
    }
  })], 1)])])]) : _vm._e(), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }